import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chart_bar_fill",
  "use": "icon-chart_bar_fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-chart_bar_fill\"><defs><clipPath id=\"icon-chart_bar_fill_master_svg0_29_12317\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\" /></clipPath></defs><g clip-path=\"url(#icon-chart_bar_fill_master_svg0_29_12317)\"><g><g></g><g><path d=\"M13,3C14.0466,2.999669313,14.9165,3.806323,14.995,4.85L15,5L15,21L9,21L9,5C8.99967,3.953375,9.80632,3.0834963,10.85,3.00500011L11,3L13,3ZM20,8C21.1046,8,22,8.895430000000001,22,10L22,19C22,20.1046,21.1046,21,20,21L17,21L17,8L20,8ZM7,11L7,21L4,21C2.895431,21,2,20.1046,2,19L2,13C2,11.89543,2.895431,11,4,11L7,11Z\" fill=\"#6C5FFC\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chart_bar_fill.svg
// module id = DXv1
// module chunks = 119